export default {
    AGUARDANDO_ANALISE: 'Aguardando Análise',
    REENVIADO: 'Reenviado',
    CREDENCIADO: 'Credenciado',
    NAO_CREDENCIADO: 'Não Credenciado'
}